import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      text: "Conseguí mi cita de NIE en Valencia. Muy profesional y rápido. Recomendado 100%.",
      author: "Ahmed",
      location: "Valencia",
      rating: 5
    },
    {
      id: 2,
      text: "Excelente servicio. Me ayudaron con la renovación de forma rápida y eficiente. Muy satisfecho.",
      author: "María",
      location: "Madrid",
      rating: 5
    },
    {
      id: 3,
      text: "Muy confiable. Pude conseguir mi cita de huellas sin problemas. El proceso fue muy sencillo.",
      author: "Carlos",
      location: "Barcelona",
      rating: 5
    },
    {
      id: 4,
      text: "Trabajé con ellos para gestionar varias citas de asilo. Profesionales y siempre disponibles.",
      author: "Sofia",
      location: "Sevilla",
      rating: 5
    },
    {
      id: 5,
      text: "Increíble servicio. Conseguí mi cita en menos de una semana. Muy recomendable para todos.",
      author: "David",
      location: "Bilbao",
      rating: 5
    },
    {
      id: 6,
      text: "El mejor servicio de gestión de citas. Transparente, rápido y eficiente. Gracias por todo.",
      author: "Laura",
      location: "Málaga",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <FaStar key={i} className={i < rating ? 'star-filled' : 'star-empty'} />
    ));
  };

  return (
    <section id="reviews" className="reviews">
      <div className="reviews-bg-image">
        <img 
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80" 
          alt="Testimonios de clientes" 
          className="reviews-image"
        />
        <div className="reviews-image-overlay"></div>
      </div>
      <div className="container">
        <h2 className="section-title">Lo Que Dicen Nuestros Clientes</h2>
        <p className="section-subtitle">Testimonios reales de clientes satisfechos</p>
        
        <div className="reviews-swiper-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            slidesPerGroup={3}
            pagination={{ 
              clickable: true,
              dynamicBullets: true
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={false}
            speed={600}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
                slidesPerGroup: 1
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 25,
                slidesPerGroup: 2
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3
              }
            }}
            className="reviews-swiper"
          >
            {reviews.map((review) => (
              <SwiperSlide key={review.id}>
                <div className="review-card">
                  <div className="review-quote-icon">
                    <FaQuoteLeft />
                  </div>
                  <div className="review-stars">
                    {renderStars(review.rating)}
                  </div>
                  <p className="review-text">"{review.text}"</p>
                  <div className="review-author-info">
                    <p className="review-author">{review.author}</p>
                    <p className="review-location">{review.location}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
